import api from '../services/api';
import CategoriasManagerModal from './CategoriasManagerModal';

/**
 * Wrapper que aplica el componente genérico CategoriasManagerModal a la API
 * de categorías de plantillas.
 */
const PlantillaCategoriasModal = ({ open, onClose, onChanged }) => (
    <CategoriasManagerModal
        open={open}
        onClose={onClose}
        onChanged={onChanged}
        title="Gestionar categorías de plantilla"
        placeholder="Ej: WEB - Tienda online"
        countField="plantillas_count"
        countLabel="plantilla"
        api={{
            list: () => api.plantillas.getCategorias(),
            create: (data) => api.plantillas.createCategoria(data),
            update: (id, data) => api.plantillas.updateCategoria(id, data),
            delete: (id) => api.plantillas.deleteCategoria(id)
        }}
    />
);

export default PlantillaCategoriasModal;
